$(document).ready(function($) {
    var slideSpeed = 4000;
    $('.facts__slides').each(function(index, el) {
        $(this).slick({
            speed: 900,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: slideSpeed,
            fade: true
        });
        slideSpeed = slideSpeed + 500
    });
});
